import { Globe } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { Button } from "./ui/button";

const LanguageToggle = ({ className = "" }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className={`gap-2 text-sm font-medium ${className}`}
      data-testid="language-toggle"
    >
      <Globe className="w-4 h-4" />
      {language === 'en' ? 'Español' : 'English'}
    </Button>
  );
};

export default LanguageToggle;
